import React, {useState} from 'react';
import {Button, Dialog} from '@betareader/design-system';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {withTranslation} from 'react-i18next';
import {useParams} from 'react-router';
import {authUtil} from '../../utils';
import TextAreaWithSave from '../../components/inputs/TextAreaWithSave';
import {createBookPost} from '../../modules/bookPost';
import {toast} from 'react-toastify';

export const ContentUpdateConfirmationModal = ({
  creatingBookPost, updateText: initialText, header, open, affectedReaders,
  sendUpdateOnConfirm, createBookPost, onCancel, onConfirm, t,
}) => {
  const [updateText, setUpdateText] = useState(initialText ?? '');
  const {bookId} = useParams();

  const handleConfirm = async sendUpdate => {
    if (creatingBookPost) return;
    if (!sendUpdate) {
      onConfirm?.();
      return;
    }
    try {
      const idToken = await authUtil.getFreshIdToken();
      createBookPost(idToken, bookId, {text: updateText}, (success, error) => {
        if (success) {
          setUpdateText('');
          onConfirm?.();
        } else {
          toast.info(error || t('SomethingWentWrong'));
        }
      });
    } catch (error) {
      toast.info(error.message || t('SomethingWentWrong'));
    }
  };

  const handleCancel = () => {
    setUpdateText('');
    onCancel?.();
  };

  return (
    <Dialog open={Boolean(open)} title={header || t('AreYouSure?')}
      onClose={handleCancel}
      actions={
        <>
          <Button variant='secondary' disabled={creatingBookPost} onClick={handleCancel}>
            {t('Cancel')}
          </Button>
          {!sendUpdateOnConfirm && (
            <Button variant='secondary' disabled={creatingBookPost}
              onClick={() => handleConfirm(false)}>{t('OnlySave')}</Button>
          )}
          <Button disabled={creatingBookPost} aria-busy={creatingBookPost}
            onClick={() => handleConfirm(true)}>{t('Send')}</Button>
        </>
      }>
      {affectedReaders?.length > 0 && (
        <div>
          <p>{t('ThisChangeAffectsTheFollowingReaders')}</p>
          <ul style={{maxHeight: 200, overflowY: 'auto'}}>
            {affectedReaders.map(reader => (
              <li key={reader._id || reader.user?._id || reader.user?.displayName}>
                {reader.user?.displayName}
              </li>
            ))}
          </ul>
        </div>
      )}
      <label className='br-field' htmlFor='content-update-text'>
        <span className='br-field__label'>{t('LetYourReadersKnowWhatYouChanged')}</span>
        <TextAreaWithSave id='content-update-text' rows={5}
          placeholder={t('SampleChapterUpdatePost')} value={updateText}
          onChange={event => setUpdateText(event.target.value)}
          onSave={() => handleConfirm(Boolean(sendUpdateOnConfirm))} />
      </label>
    </Dialog>
  );
};

const mapStateToProps = state => ({creatingBookPost: state.bookPost.creatingBookPost});
const mapDispatchToProps = dispatch => bindActionCreators({createBookPost}, dispatch);

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(ContentUpdateConfirmationModal));
